"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonIcon = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _badge = require("@oneloop/badge");
var _box = require("@oneloop/box");
var _checkbox = require("@oneloop/checkbox");
var _icons = require("@oneloop/icons");
var _image = require("@oneloop/image");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
require("@oneloop/fonts");
var _excluded = ["variant"],
  _excluded2 = ["icon", "variant", "text", "badgeValue", "badgeVariant", "maxWidth", "srcImage", "userImage", "hasCheckbox", "active", "isCollapsible", "disabled", "holdPress", "hover", "filled", "isExpanded", "widthImage", "heightImage", "setExpand", "testForAction"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Button = exports.Button = function Button(_ref) {
  var variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "button",
    tx: "buttons",
    type: "button",
    variant: variant
  }, props, {
    __css: {
      appearance: 'none',
      display: 'flex',
      lineHeight: 'inherit',
      fontFamily: 'Nunito Sans',
      textAlign: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      outline: 'none',
      border: 0,
      flexDirection: 'row',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      justifyContent: 'center',
      fontWeight: 'bold',
      borderRadius: '12px'
    }
  })));
};
var ButtonIcon = exports.ButtonIcon = function ButtonIcon(_ref2) {
  var icon = _ref2.icon,
    variant = _ref2.variant,
    text = _ref2.text,
    _ref2$badgeValue = _ref2.badgeValue,
    badgeValue = _ref2$badgeValue === void 0 ? 0 : _ref2$badgeValue,
    _ref2$badgeVariant = _ref2.badgeVariant,
    badgeVariant = _ref2$badgeVariant === void 0 ? ['badgeNormal', 'primary'] : _ref2$badgeVariant,
    maxWidth = _ref2.maxWidth,
    srcImage = _ref2.srcImage,
    userImage = _ref2.userImage,
    hasCheckbox = _ref2.hasCheckbox,
    active = _ref2.active,
    isCollapsible = _ref2.isCollapsible,
    disabled = _ref2.disabled,
    holdPress = _ref2.holdPress,
    hover = _ref2.hover,
    filled = _ref2.filled,
    isExpanded = _ref2.isExpanded,
    widthImage = _ref2.widthImage,
    heightImage = _ref2.heightImage,
    setExpand = _ref2.setExpand,
    testForAction = _ref2.testForAction,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var colorValue;
  var colorValueIcon;
  var fontSize;
  var fontWeight;
  var fontSizeIcon;
  if (Array.isArray(variant)) {
    var indexes = variant.map(function (v) {
      return Object.keys(_theme["default"].buttons).indexOf(v);
    });
    indexes.map(function (index) {
      var variantValues = Object.values(_theme["default"].buttons)[index];
      if (variantValues[':focus'] !== undefined && active) {
        colorValue = variantValues[':focus'].color;
        fontWeight = variantValues[':focus'].fontWeight;
        if (variantValues.colorIcon !== undefined) {
          colorValueIcon = variantValues[':focus'].colorIcon;
        }
      }
      if (colorValue === undefined && variantValues.color !== undefined) {
        colorValue = variantValues.color;
      }
      if (colorValueIcon === undefined && variantValues.colorIcon !== undefined) {
        colorValueIcon = variantValues.colorIcon;
      }
      if (fontWeight === undefined && variantValues.fontWeight !== undefined) {
        fontWeight = variantValues.fontWeight;
      }
      if (fontSize === undefined && variantValues.fontSize !== undefined) {
        fontSize = variantValues.fontSize;
      }
      if (filled && colorValueIcon === undefined) {
        colorValueIcon = variantValues.colorFilled;
      }
      if (fontSizeIcon === undefined) {
        fontSizeIcon = variantValues.fontSizeIcon;
      }
      return colorValue;
    });
  } else {
    var index = Object.keys(_theme["default"].buttons).indexOf(variant);
    var variantValues = Object.values(_theme["default"].buttons)[index];
    if (variantValues !== undefined) {
      colorValue = variantValues.color;
      colorValueIcon = variantValues.colorIcon || (filled && colorValueIcon === undefined ? variantValues.colorFilled : variantValues.color);
      fontSize = variantValues.fontSize;
      fontWeight = variantValues.fontWeight;
      if (hover) {
        colorValue = variantValues[':hover'].color;
        colorValueIcon = variantValues[':hover'].colorIcon;
        fontWeight = variantValues[':hover'].fontWeight;
      } else if (active) {
        colorValue = variantValues[':focus'].color;
        colorValueIcon = variantValues[':focus'].colorIcon;
        fontWeight = variantValues[':focus'].fontWeight;
      }
      if (fontSizeIcon === undefined) {
        fontSizeIcon = variantValues.fontSizeIcon;
      }
    }
  }
  if (badgeValue > 99) {
    badgeValue = '+99';
  }
  if (testForAction) {
    console.log('It has a boolean testForAction.');
  }
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    sx: maxWidth ? {
      position: 'relative',
      width: '100%'
    } : {
      position: 'relative'
    }
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "button",
    tx: "buttons",
    type: "button",
    variant: variant
  }, props, {
    __css: {
      appearance: 'none',
      display: 'flex',
      lineHeight: 'inherit',
      fontFamily: 'Nunito Sans',
      fontWeight: fontWeight || 'bold',
      textAlign: 'center',
      textDecoration: 'none',
      cursor: 'pointer',
      outline: 'none',
      border: 0,
      flexDirection: 'row',
      justifyContent: !maxWidth && 'center',
      width: maxWidth && '100%',
      alignItems: 'center',
      whiteSpace: 'nowrap',
      position: 'relative'
    }
  }), hasCheckbox && active && /*#__PURE__*/_react["default"].createElement(_checkbox.Checkbox, {
    defaultChecked: true,
    disabled: disabled
  }), hasCheckbox && !active && /*#__PURE__*/_react["default"].createElement(_checkbox.Checkbox, {
    defaultChecked: false,
    disabled: disabled
  }), icon && /*#__PURE__*/_react["default"].createElement(_icons.Icon, {
    icon: icon,
    fontSize: fontSizeIcon || fontSize,
    style: holdPress && {
      color: colorValueIcon || colorValue
    }
  }), !userImage && srcImage && /*#__PURE__*/_react["default"].createElement(_image.Image, {
    src: srcImage,
    style: {
      width: widthImage,
      height: heightImage
    }
  }), userImage && srcImage && /*#__PURE__*/_react["default"].createElement(_image.Image, {
    src: srcImage,
    variant: "avatar"
  }), userImage && !srcImage && /*#__PURE__*/_react["default"].createElement("span", {
    className: "icon-contactos",
    style: {
      fontSize: '24px'
    }
  }), text && !holdPress && /*#__PURE__*/_react["default"].createElement("span", null, text), text && holdPress && /*#__PURE__*/_react["default"].createElement("span", {
    style: colorValue && {
      color: colorValue,
      fontWeight: fontWeight
    }
  }, text), isCollapsible && setExpand === undefined && /*#__PURE__*/_react["default"].createElement("span", {
    className: "icon-dropdown",
    style: {
      position: 'absolute',
      right: '10px',
      color: '#798B97',
      fontSize: '14px',
      transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)',
      transition: 'all 0.5s',
      paddingTop: '4px'
    }
  }), isCollapsible && setExpand !== undefined && /*#__PURE__*/_react["default"].createElement("span", {
    className: "icon-dropdown",
    onClick: function onClick(event) {
      event.preventDefault();
      setExpand();
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();
    },
    style: {
      position: 'absolute',
      right: '10px',
      color: '#798B97',
      fontSize: '14px',
      transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)',
      transition: 'all 0.5s',
      paddingTop: '4px',
      paddingLeft: '1px',
      paddingRight: '1px'
    }
  }), badgeValue !== 0 && !text && /*#__PURE__*/_react["default"].createElement(_badge.Badge, {
    variant: badgeVariant,
    isNotButton: true,
    style: {
      position: 'absolute',
      top: '2px',
      left: '16px'
    }
  }, badgeValue), badgeValue !== 0 && text && /*#__PURE__*/_react["default"].createElement(_badge.Badge, {
    variant: badgeVariant,
    isNotButton: true,
    style: {
      position: 'absolute',
      right: isCollapsible ? '30px' : '10px'
    }
  }, badgeValue)));
};